<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>Confederate Gold / Dead Man's Gold</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=utf-8" http-equiv="content-type"/>
<div id="cov">
<img alt="image" src="Images/cover.jpg" style="height:100%;"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312943349_cov.vue?1a0f2e86